'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _number_utility = require('../../../packages/common-utilities/src/number_utility.js');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _click_or_escape_outside = require('./click_or_escape_outside.js');

var _click_or_escape_outside2 = _interopRequireDefault(_click_or_escape_outside);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _dropdown_component = require('./global_components/dropdown_component.js');

var _dropdown_component2 = _interopRequireDefault(_dropdown_component);

var _table_component = require('./global_components/table_component.js');

var _table_component2 = _interopRequireDefault(_table_component);

var _pagination_input = require('./pagination_input.js');

var _pagination_input2 = _interopRequireDefault(_pagination_input);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _formatted_number = require('./global_components/formatted_number');

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _readable_field_component = require('./global_components/readable_field_component');

var _ramda = require('ramda');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _collection_utility = require('common-utilities/src/collection_utility');

var _accessibility_utility = require('../../../packages/common-utilities/src/accessibility_utility');

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

var _constants = require('../../../packages/common-utilities/src/constants.js');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var HoldingsSecurityCard = function (_Component) {
  _inherits(HoldingsSecurityCard, _Component);

  function HoldingsSecurityCard(props) {
    _classCallCheck(this, HoldingsSecurityCard);

    var _this = _possibleConstructorReturn(this, (HoldingsSecurityCard.__proto__ || Object.getPrototypeOf(HoldingsSecurityCard)).call(this, props));

    _this.setPaginationInputFocus = function () {
      _this.child.setFocusFromParent();
    };

    _this.onClose = _this.onClose.bind(_this);
    _this.onCloseRowDrop = _this.onCloseRowDrop.bind(_this);

    var orderedData = [];

    if (!(0, _functional_utility.isNilOrEmpty)(_this.props.data)) {
      var listData = _this.props.data.data;
      orderedData = listData;
      if (!(0, _ramda.isNil)(listData) && !(0, _ramda.isNil)(_this.props.data.sortOrder) && !(0, _ramda.isNil)(_this.props.data.defaultSortCriteria)) {
        if (_this.props.data.sortOrder === 'desc') {
          orderedData = (0, _ramda.sortWith)([(0, _ramda.descend)((0, _ramda.prop)(_this.props.data.defaultSortCriteria))])(listData);
        } else {
          orderedData = (0, _ramda.sortWith)([(0, _ramda.ascend)((0, _ramda.prop)(_this.props.data.defaultSortCriteria))])(listData);
        }
      }
    }

    _this.state = {
      data: orderedData,
      currentPage: 1,
      currentPageDisplay: 1,
      itemsPerPage: 10,
      selectedRowValue: _this.props.intl.formatMessage({ id: "pdp-holdings-security-view-10-label", defaultMessage: "View 10" }),
      sortOrderAsc: !(0, _functional_utility.isNilOrEmpty)(_this.props.data) ? _this.props.data.sortOrder === 'asc' : false,
      sortBy: !(0, _functional_utility.isNilOrEmpty)(_this.props.data) ? _this.props.data.defaultSortCriteria : null
    };

    _this.prevPage = _this.prevPage.bind(_this);
    _this.nextPage = _this.nextPage.bind(_this);
    _this.setPaginationInputFocus = _this.setPaginationInputFocus.bind(_this);
    _this.changeItemsPerPage = _this.changeItemsPerPage.bind(_this);
    _this.changeDateFilter = _this.changeDateFilter.bind(_this);
    _this.changeSortFilter = _this.changeSortFilter.bind(_this);
    _this.setCurrentPageDisplay = _this.setCurrentPageDisplay.bind(_this);
    _this.updateCurrentPage = function (pageNo) {
      _this.setCurrentPageDisplay(pageNo);
    };
    return _this;
  }

  _createClass(HoldingsSecurityCard, [{
    key: 'onClose',
    value: function onClose() {
      this.childRef.focus();
    }
  }, {
    key: 'onCloseRowDrop',
    value: function onCloseRowDrop() {
      this.childRefRowDrop.focus();
    }
  }, {
    key: 'displayRowLabels',
    value: function displayRowLabels() {
      var _this2 = this;

      var items = [];

      var options = [10, 20, 50].map(function (count) {
        return {
          value: 'view-' + count,
          displayValue: _this2.props.intl.formatMessage({
            id: 'pdp-holdings-security-view-' + count + '-label',
            defaultMessage: 'View ' + count
          })
        };
      });
      mapIndexed(function (option, index) {
        _this2[option.value + 'displayRowsDropdown'] = _react2.default.createRef();
        var isLastElement = options.length - 1 === index;
        items.push(_react2.default.createElement(
          'div',
          { key: index, 'data-option-value': option.value, 'data-display-value': option.displayValue,
            onClick: _this2.changeItemsPerPage,
            ref: _this2[option.value + 'displayRowsDropdown'],
            onKeyDown: function onKeyDown(event) {
              return _accessibility_utility2.default.handleDropdownEvents(_this2, event, '#display-row-selector', option.value + 'displayRowsDropdown', 'view-10displayRowsDropdown', isLastElement, function () {
                return _this2.changeItemsPerPage(event);
              });
            },
            tabIndex: 0, className: 'dropdown-list-item', role: 'option' },
          _react2.default.createElement(
            'span',
            { className: 'font-light caption', 'data-option-value': option.value,
              'data-display-value': option.displayValue },
            option.displayValue
          )
        ));
      }, options);
      return items;
    }
  }, {
    key: 'setCurrentPageDisplay',
    value: function setCurrentPageDisplay(pageNo) {

      if (!isNaN(pageNo) && pageNo > 0) {
        this.setState({ currentPage: Number(pageNo), currentPageDisplay: Number(pageNo) });
      } else {
        this.setState({ currentPageDisplay: "" });
      }
      this.props.cardDataChanged();
    }
  }, {
    key: 'renderHoldingsDataRows',
    value: function renderHoldingsDataRows() {
      var _this3 = this;

      if ((0, _ramda.isNil)(this.state.data)) {
        return null;
      }
      var _state = this.state,
          currentPage = _state.currentPage,
          itemsPerPage = _state.itemsPerPage,
          _state$data = _state.data,
          data = _state$data === undefined ? [] : _state$data;

      var indexOfLastItem = currentPage * itemsPerPage;
      var indexOfFirstItem = indexOfLastItem - itemsPerPage;
      var currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

      var formatNumber = function formatNumber(data, field) {
        var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
        var decimalPlaces = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        return _react2.default.createElement(
          'td',
          { className: 'margin-top-5', 'data-testid': 'holdings-security-data-' + field },
          _react2.default.createElement(_formatted_number2.default, { value: _number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(data[field], decimalPlaces)), numberFormat: _this3.props.numberFormat }),
          suffix
        );
      };
      var raw = function raw(data, field) {
        return _react2.default.createElement(
          'td',
          { className: 'margin-top-5', 'data-testid': 'holdings-security-data-' + field },
          data[field]
        );
      };

      var getFormattedValue = function getFormattedValue(dataType, data, field) {
        switch (dataType) {
          case _constants2.default.getDataPointSuffix().PERCENTAGE.key:
            return formatNumber(data, field, "%", 2);
          case _constants2.default.getDataPointSuffix().NUMBER.key:
            return formatNumber(data, field);
          default:
            return raw(data, field);
        }
      };

      return mapIndexed(function (holdingsData, i) {
        var fields = (0, _functional_utility.pathOrEmptyArray)(['data', 'visibleFields'], _this3.props);
        return _react2.default.createElement(
          'tr',
          { key: i, className: 'padding-vertical-5 category row-divider',
            'data-testid': 'holdings-security-row' },
          fields.map(function (field) {
            return getFormattedValue(_this3.props.data.visibleFieldDataTypes[field], holdingsData, field);
          })
        );
      }, currentItems);
    }
  }, {
    key: 'getFormattedDate',
    value: function getFormattedDate(date) {
      if ((0, _functional_utility.isNilOrEmpty)(date)) {
        return "-";
      }
      return _date_formatter2.default.getLocalFormattedDateForInjectIntl(date, this.props.intl);
    }
  }, {
    key: 'getFormattedDateWithoutTimezone',
    value: function getFormattedDateWithoutTimezone(date) {
      if ((0, _functional_utility.isNilOrEmpty)(date)) {
        return "-";
      }
      return _date_formatter2.default.getLocalFormattedDateForInjectIntl(date, this.props.intl, false);
    }
  }, {
    key: 'renderHeaderRow',
    value: function renderHeaderRow(labels) {
      var _this4 = this;

      var columns = (0, _functional_utility.pathOrEmptyArray)(['data', 'visibleFields'], this.props);
      var row = [];
      _collection_utility.CollectionUtility.forEachIndexed(labels, function (value, i) {
        var sortIndicator = "ct-icon ct-icon-caret-down large-sorter";
        var sortLabel = "none";
        var columnActive = "";
        if (columns[i] === _this4.state.sortBy) {
          columnActive = 'font-teal';
          sortIndicator = "ct-icon ct-icon-caret-down font-teal active large-sorter";
          sortLabel = "ascending";
          if (!_this4.state.sortOrderAsc) {
            sortIndicator = "ct-icon ct-icon-caret-up font-teal active large-sorter";
            sortLabel = "descending";
          }
        }
        row.push(_react2.default.createElement(
          'th',
          { key: i, style: { "verticalAlign": "middle" }, 'aria-sort': sortLabel },
          _react2.default.createElement(
            'div',
            { tabIndex: 0, role: 'button',
              onClick: _this4.changeSortFilter,
              onKeyPress: function onKeyPress(event) {
                _accessibility_utility2.default.handleSpaceOrEnterClick(_this4, event, _this4.changeSortFilter.bind(_this4, event));
              },
              'data-column': columns[i], 'data-testid': columns[i] + '-label', key: value, className: 'display-flex curs align-items-center tag cursor-pointer ' + columnActive },
            _react2.default.createElement(
              'span',
              { 'data-testid': columns[i] + '-value', 'data-column': columns[i], className: "white-space-pre" },
              value
            ),
            _react2.default.createElement('span', { 'data-testid': columns[i] + '-icon', 'data-column': columns[i], className: sortIndicator })
          )
        ));
      });

      return row;
    }
  }, {
    key: 'prevPage',
    value: function prevPage() {
      var prevPage = Math.max(this.state.currentPage - 1, 1);
      if (prevPage === 1) {
        this.setPaginationInputFocus();
      }
      this.setCurrentPageDisplay(prevPage);
    }
  }, {
    key: 'nextPage',
    value: function nextPage() {
      var _state2 = this.state,
          currentPage = _state2.currentPage,
          itemsPerPage = _state2.itemsPerPage,
          _state2$data = _state2.data,
          data = _state2$data === undefined ? [] : _state2$data;

      var totalPages = Math.ceil(data.length === 0 ? 1 : data.length / itemsPerPage);
      var nextPage = currentPage + 1;

      if (nextPage > totalPages) {
        nextPage = totalPages;
      } else if (nextPage === totalPages) {
        this.setPaginationInputFocus();
      }

      this.setCurrentPageDisplay(nextPage);
    }
  }, {
    key: 'changeItemsPerPage',
    value: function changeItemsPerPage(event) {
      var selectedRowValue = event.target.getAttribute("data-option-value") || "view-10";
      var selectedRowDisplayValue = event.target.getAttribute("data-display-value") || "View 10";
      var selectedCount = selectedRowValue.replace("view-", "");
      this.setState({
        itemsPerPage: Number(selectedCount),
        selectedRowValue: selectedRowDisplayValue,
        currentPage: 1,
        currentPageDisplay: 1
      });
      this.setCurrentPageDisplay(1);
    }
  }, {
    key: 'changeDateFilter',
    value: function changeDateFilter(event) {
      this.setState({
        dateToFilterBy: event.target.getAttribute("data-option-value"),
        dateToFilterByDisplayValue: event.target.getAttribute("data-display-value")
      });
      this.setCurrentPageDisplay(1);
    }
  }, {
    key: 'changeSortFilter',
    value: function changeSortFilter(event) {
      var sortOrderAsc = true;
      var targetColumn = event.target.getAttribute("data-column");

      var sortedHoldings = (0, _ramda.sortBy)((0, _ramda.prop)(targetColumn))(this.props.data.data);

      if (targetColumn === this.state.sortBy) {
        sortOrderAsc = !this.state.sortOrderAsc;
        if (!sortOrderAsc) {
          sortedHoldings = sortedHoldings.reverse();
        }
      }
      this.setState({
        data: sortedHoldings,
        sortBy: targetColumn,
        sortOrderAsc: sortOrderAsc
      });
      this.setCurrentPageDisplay(1);
    }
  }, {
    key: 'getDefaultDateToFilterBy',
    value: function getDefaultDateToFilterBy() {
      if (this.state.dateToFilterByDisplayValue) {
        return this.getFormattedDateWithoutTimezone(this.state.dateToFilterByDisplayValue);
      }

      return this.getFormattedDate(this.props.data.effectiveDate);
    }
  }, {
    key: 'displayPagination',
    value: function displayPagination(currentPageDisplay, totalNumberOfPages) {
      var _this5 = this;

      var leftArrowStyling = currentPageDisplay === 1 ? "display-none" : "font-super-black";
      var rightArrowStyling = currentPageDisplay === totalNumberOfPages ? "display-none" : "font-super-black";

      if (totalNumberOfPages <= 1) {
        return null;
      } else {
        return _react2.default.createElement(
          'div',
          {
            className: '' + (this.props.breakpoint < 2 ? "col-xs-12 col-sm-12 text-center padding-vertical-20" : "text-right margin-top-30 float-right"),
            'data-testid': 'holdings-security-pagination' },
          _react2.default.createElement(
            'a',
            { className: 'text-decoration-none-important border-all-1 border-super-black border-radius-50 padding-horizontal-2 padding-bottom-3 ' + leftArrowStyling,
              tabIndex: 0,
              onClick: this.prevPage,
              onKeyDown: function onKeyDown(event) {
                return _accessibility_utility2.default.handleEnterClick(_this5, event, _this5.prevPage);
              },
              'data-testid': 'holdings-security-left-chevron', 'aria-label': "Previous page" },
            _react2.default.createElement('span', { className: 'icon-leftchevron' })
          ),
          _react2.default.createElement(_pagination_input2.default, { initialPageNumber: currentPageDisplay, onChange: this.updateCurrentPage,
            ref: function ref(c) {
              return _this5.child = c;
            }
          }),
          _react2.default.createElement(
            'span',
            { 'data-testid': 'holdings-security-total-pages',
              className: 'margin-right-10 tag' },
            '/ ',
            totalNumberOfPages
          ),
          _react2.default.createElement(
            'a',
            { className: 'text-decoration-none-important border-all-1 border-super-black border-radius-50 padding-horizontal-2 padding-bottom-3 ' + rightArrowStyling,
              tabIndex: currentPageDisplay === totalNumberOfPages ? -1 : 0,
              onClick: this.nextPage,
              onKeyDown: function onKeyDown(event) {
                return _accessibility_utility2.default.handleEnterClick(_this5, event, _this5.nextPage);
              },
              'data-testid': 'holdings-security-right-chevron', 'aria-label': "Next page" },
            _react2.default.createElement('span', { className: 'icon-rightchevron' })
          )
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      if ((0, _ramda.isNil)(this.props.data)) {
        return null;
      }
      var _state3 = this.state,
          itemsPerPage = _state3.itemsPerPage,
          _state3$data = _state3.data,
          data = _state3$data === undefined ? [] : _state3$data;

      var selectedRowValue = this.state.selectedRowValue;
      var totalNumberOfPages = Math.ceil(data.length / itemsPerPage);

      var labels = (0, _functional_utility.pathOrEmptyArray)(['data', 'visibleFields'], this.props).map(function (field) {
        return _this6.props.intl.formatMessage({ defaultMessage: field, id: 'pdp-holdings-security-' + _this6.props.holdingType + '-' + field });
      });

      return _react2.default.createElement(
        'div',
        { className: 'portfolio-child-card', 'data-testid': 'holdings-security-holdings-card' },
        _react2.default.createElement(
          _card_component2.default,
          {
            headerTitle: this.props.header,
            headerTitleId: this.props.id,
            breakpoint: this.props.breakpoint,
            placementId: this.props.placementId,
            disclosureText: this.props.disclosureText,
            headerTitleLabel: "holdings-security-header"
          },
          _react2.default.createElement(
            'div',
            {
              className: 'margin-right-30 padding-bottom-30 ' + (this.props.breakpoint < 2 ? "col-xs-12 col-sm-12" : "width-140 float-left") },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'font-black-variant tag-2 margin-bottom-5', role: 'label', id: 'ReportDate' },
                this.props.intl.formatMessage({ defaultMessage: 'As of', id: 'pdp-holdings-security-as-of-date-label' })
              ),
              _react2.default.createElement(_readable_field_component.ReadableField, {
                key: 'report-date',
                value: this.getDefaultDateToFilterBy(),
                additionalClassName: 'report-date-selector',
                dataTest: "report-date"
              })
            )
          ),
          this.props.breakpoint > 2 && _react2.default.createElement(
            'div',
            { className: 'width-140 display-inline-block padding-bottom-30 vertical-align-top' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'font-black-variant tag-2 margin-bottom-5', role: 'label', id: 'DisplayRows' },
                this.props.intl.formatMessage({ defaultMessage: 'DISPLAY ROWS', id: 'pdp-holdings-security-view-label' })
              ),
              _react2.default.createElement(
                _click_or_escape_outside2.default,
                { id: 'dropdownRowLabels', onClose: this.onCloseRowDrop },
                _react2.default.createElement(_dropdown_component2.default, {
                  dropdownContent: this.displayRowLabels(),
                  id: 'display-row-selector',
                  className: 'width-120',
                  breakpoint: this.props.breakpoint,
                  initialActiveSelect: selectedRowValue,
                  alwaysOpenOnSelect: false,
                  ariaLabelledby: 'DisplayRows',
                  setRefDropdown: function setRefDropdown(node) {
                    return _this6.childRefRowDrop = node;
                  }
                })
              )
            )
          ),
          _react2.default.createElement(_table_component2.default, {
            tableHeaders: this.renderHeaderRow(labels),
            tableRows: this.renderHoldingsDataRows(),
            tableBodyTest: 'holdings-security-body',
            activeTab: this.props.activeTab,
            breakpoint: this.props.breakpoint
          }),
          _react2.default.createElement(
            'div',
            { id: 'holdings-footer' },
            this.displayPagination(this.state.currentPageDisplay, totalNumberOfPages)
          )
        )
      );
    }
  }]);

  return HoldingsSecurityCard;
}(_react.Component);

exports.default = (0, _reactIntl.injectIntl)(HoldingsSecurityCard, { withRef: true });